module.exports = __webpack_public_path__ + "static/img/l-3.6d1b3cfd.png";